module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-3.b8e062bd.jpg";